import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckSimple = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.8125 7.96875L6.5625 11.7188L12.1875 3.28125",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckSimple;
